
import EditorList from "Editors/EditorList";

export default {
  components: {
    EditorList,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1.15,
        spaceBetween: 10,
        initialSlide: 2,
        autoHeight: false,
        observer: true,
        observeParents: true,
        updateOnImagesReady: true,
        breakpoints: {
          768: {
            spaceBetween: 12,
            slidesPerView: 2,
            centeredSlides: true,
          },
        },
      },
      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "logo",
          label: "Logo",
          type: "image",
          size: "400x400",
        },
        {
          name: "link",
          label: "Poveznica",
          type: "link",
        },
        {
          name: "priceMonth",
          label: "Cijena za mjesec",
          type: "text",
        },
        {
          name: "priceAnual",
          label: "Cijena za godinu",
          type: "text",
        },
        {
          name: "priceHourly",
          label: "Cijena po satu",
          type: "text",
        },
      ],
    };
  },
};
